export class DataGroupDto {
  keyId: string = '';
  id: string = '';
  parentId: string = '';
  code: string = '';
  name: string = '';
  children?: Array<DataGroupDto>;
}